import { render, staticRenderFns } from "./HeartysanCategoryFilter.vue?vue&type=template&id=282df7d9&scoped=true"
import script from "./HeartysanCategoryFilter.vue?vue&type=script&lang=js"
export * from "./HeartysanCategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282df7d9",
  null
  
)

export default component.exports